
import { Component, Mixins } from "vue-property-decorator";
import WizardMixin from "@/views/wizard/wizard.mixin";
import GoogleAutocomplete from "@/common/components/google-autocomplete.vue";
import GoogleAddressMixin from '@/common/mixins/google-address.mixin';
import { mapState } from "vuex";
import { WizardInformationFormDto } from "@/types/wizard.type";
import { WizardStep } from "@/types/enums.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  components: {
    GoogleAutocomplete
  },
  computed: {
    ...mapState('Wizard', { form: 'infoForm' })
  }
})
export default class WizardInformationComponent extends Mixins(WizardMixin, GoogleAddressMixin, ValidatedFormMixin) {
  form!: WizardInformationFormDto;
  WizardStep = WizardStep;

  mounted(): void {
    if (this.form.address1){
      this.setAddressString(this.form);
    }
  }

  finishForm(): void {
    this.$validator.validateAll().then((isValid: boolean) => {
      if (isValid) {
        this.$validator.reset();
        
        this.next(WizardStep.Schedulers);
      }
    });
  }
}
